var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tabs" }, [
    _vm.$mq !== "mobile"
      ? _c(
          "div",
          { staticClass: "tabs__nav" },
          _vm._l(_vm.tabs, function (tab) {
            return _c(
              "button",
              {
                staticClass: "tabs__nav__button",
                class: { active: tab.active },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.activate(tab)
                  },
                },
              },
              [_vm._v(_vm._s(tab.heading))]
            )
          }),
          0
        )
      : _vm._e(),
    _c("div", { staticClass: "tabs__content" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }